export const gerDate = (date) => {
  return (new Date(date)).toLocaleDateString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

export const moneyFormat = (money) => {
  const format = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: money.currency
  })
  return format.format(money.amount / 100)
}
